import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
import CommentPost from 'flarum/forum/components/CommentPost';
export default function () {
  extend(PostControls, 'moderationControls', function (items, post) {
    const discussion = post.discussion();
    if (post.contentType() !== 'comment' || !discussion.canSplit() || post.number() == 1) return;
    if (!app.__fof_split.splitting) {
      items.add('splitFrom', [m(Button, {
        icon: 'fas fa-code-branch',
        className: 'flagrow-split-startSplitButton',
        onclick: () => {
          var _app$__fof_split$spli;
          (_app$__fof_split$spli = app.__fof_split.splitController) == null || _app$__fof_split$spli.start(post.id(), post.number());
        }
      }, app.translator.trans('fof-split.forum.split.from'))]);
    }
  });
  extend(CommentPost.prototype, 'oninit', function () {
    this.subtree.check(() => app.__fof_split.splitting);
  });
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    const discussion = post.discussion();
    if (post.contentType() !== 'comment' || !discussion.canSplit() || post.number() === 1) return;
    if (app.__fof_split.splitting && app.__fof_split.splittingFrom && post.number() >= app.__fof_split.splittingFrom) {
      items.add('splitTo', [m(Button, {
        icon: "fas fa-code-branch",
        className: "flagrow-split-endSplitButton Button Button--link",
        onclick: () => {
          app.modal.show(() => import(/* webpackChunkName: 'forum/components/SplitPostModal', webpackMode: 'lazy-once' */ './components/SplitPostModal'), {
            post: post
          });
        }
      }, app.translator.trans('fof-split.forum.split.to')), m(Button, {
        icon: "fas fa-times",
        className: "flagrow-split-cancelSplitButton Button Button--link",
        onclick: () => {
          var _app$__fof_split$spli2;
          (_app$__fof_split$spli2 = app.__fof_split.splitController) == null || _app$__fof_split$spli2.reset();
          m.redraw();
        }
      }, app.translator.trans('fof-split.forum.split.cancel'))]);
    }
  });
}flarum.reg.addChunkModule('241', '587', 'fof-split', 'forum/components/SplitPostModal');